
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PrayerTime } from "@/types/page";

// Import our components
import PrayerTimesPreview from "./PrayerTimesPreview";
import EditorForm from "./EditorForm";
import { usePrayerTimesEditor } from "./hooks/usePrayerTimesEditor";

interface PrayerTimesEditorMainProps {
  content?: any;
  onContentChange?: (field: string, value: any) => void;
}

const PrayerTimesEditorMain: React.FC<PrayerTimesEditorMainProps> = ({ 
  content = {}, 
  onContentChange = () => {} 
}) => {
  const {
    activeTab,
    setActiveTab,
    blockTitle,
    animationSpeed,
    prayerTimes,
    hasChanges,
    isLegacyFormat,
    saveContent,
    convertToModernFormat,
    handleBlockTitleChange,
    handleAddPrayerTime,
    handleUpdatePrayerTime,
    handleRemovePrayerTime,
    handleAnimationSpeedChange,
    handleReorderPrayerTimes,
  } = usePrayerTimesEditor({ content, onContentChange });

  const handleSaveChanges = () => {
    console.log("Manually saving changes...");
    saveContent(prayerTimes, blockTitle, animationSpeed);
  };

  return (
    <div className="flex flex-col gap-6">
      <Tabs defaultValue="editor" value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="editor">עריכה</TabsTrigger>
          <TabsTrigger value="preview">תצוגה מקדימה</TabsTrigger>
        </TabsList>
        
        <TabsContent value="editor" className="mt-4">
          <Card>
            <CardHeader className="flex flex-row items-center justify-between">
              <CardTitle>עריכת זמני תפילה</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <EditorForm 
                blockTitle={blockTitle}
                onBlockTitleChange={handleBlockTitleChange}
                animationSpeed={animationSpeed}
                onAnimationSpeedChange={handleAnimationSpeedChange}
                prayerTimes={prayerTimes}
                onAddPrayerTime={handleAddPrayerTime}
                onUpdatePrayerTime={handleUpdatePrayerTime}
                onRemovePrayerTime={handleRemovePrayerTime}
                onReorderPrayerTimes={handleReorderPrayerTimes}
                onSaveChanges={handleSaveChanges}
                hasChanges={hasChanges}
                isLegacyFormat={isLegacyFormat}
                convertToModernFormat={convertToModernFormat}
              />
            </CardContent>
          </Card>
        </TabsContent>
        
        <TabsContent value="preview" className="mt-4">
          <Card className="overflow-auto">
            <CardHeader>
              <CardTitle>תצוגה מקדימה</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="w-[600px] mx-0">
                <PrayerTimesPreview 
                  prayerTimes={prayerTimes}
                  blockTitle={blockTitle}
                  animationSpeed={animationSpeed}
                />
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default PrayerTimesEditorMain;
